<template lang="html">

  <v-layout row wrap justify-center fill-height>
    <v-flex md8>
      <center>
        <h1> SEND THE MESSAGE</h1>

        <v-form

          submit>
          <v-flex xs12 md12>
            <v-text-field maxlength='50'
                          label="Your Name"
                          v-model="name"
                          id='name'
                          required></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field maxlength="50"
                          label="Phone Number"
                          v-model="phone"
                          id='phone'
                          required></v-text-field>
          </v-flex>
          <v-flex xs12 md12 mt-3>
            <v-textarea label="Message"
                        v-model="bodytext"
                        counter
                        maxlength='500'
                        id='bodytext'
                        auto-grow></v-textarea>
            <center>
              <!-- <div class="g-recaptcha" data-sitekey="6LeavKsUAAAAALsJqLc6FvrFpoUkGSsdi7zYLDgx"></div> -->
              <v-btn tile color="primary" @click='emailSubmit'>Submit</v-btn>
            </center>

          </v-flex>
        </v-form>

      </center>
    </v-flex>
</v-layout>

</template>

<script>
const axios = require('axios');
export default {
  data: () => {
    return {
        footer: [
          {
            icon: 'fab fa-facebook',
            src: 'https://www.facebook.com/Summitcrs/'
          },
          {
            icon: 'fab fa-linkedin',
            src: 'https://www.linkedin.com/company/15163057/'
          },
          {
            icon: 'fab fa-youtube',
            src: 'https://www.youtube.com/channel/UCbbIMPJtE_gyQ9oIzwdVN4Q'
          }
        ]
      }

    },
    methods: {
      emailSubmit(){

        let api = axios.create({
          baseURL: 'https://engagesms.net/app/api/ext/extSMS',
          method: 'post',
          headers: {
            'Authorization':'357a39e750d15701958abf39ada32cf8e173322dfa74e7cc965f7b4d9ea901ef'
          },
          timeout: 100000
        });

        let form_params= {
          appId: '3',
          recpNum: '2088410150',
          recpName: 'Cameron Schultz',
          recpMsg: 'EAT SHIT',
          msgType: '2',
          recpComment: "none ya"

        }

        api.post('', form_params)
          .then(response => {
            console.log('success', response.data.message)
          }).catch(error => {
            console.log(error.toJSON())
          });
      }

      }
    }
</script>
